document.addEventListener('DOMContentLoaded', function(event) {

	/* ==================================
	Инициализация всех блоков партнёров на странице
	==================================*/
	document.querySelectorAll('.partners-list').forEach(section => {
		const btn = section.querySelector('.show-all-btn');
		const hiddenCards = section.querySelectorAll('.partner-card.hidden');
		let isExpanded = false;

		btn.addEventListener('click', function() {
			isExpanded = !isExpanded;

			hiddenCards.forEach((card, index) => {
				if (isExpanded) {
					setTimeout(() => {
						card.classList.remove('hidden');
						card.classList.add('show');
						section.classList.add('is-visible')
					}, index * 50);
				} else {
					card.classList.remove('show');
					card.classList.add('hidden');
					section.classList.toggle('is-visible', false)
				}
			});

			if (isExpanded) {
				btn.textContent = 'СКРЫТЬ ПАРТНЁРОВ';
				btn.classList.add('active');
			} else {
				btn.textContent = 'ПОКАЗАТЬ ВСЕХ ПАРТНЁРОВ';
				btn.classList.remove('active');
			}
		});
	});


});